import React from 'react'
import { Box, Grid, Text } from '@mantine/core'
import ItemWrapper from '../../../components/ItemWrapper'
import LabeledTitle from '../../../components/LabeledTitle'
import { RelatedCompanyItem } from './types'
import { useTheme } from '../../../components/ThemeProvider'

interface RelatedCompaniesSummaryProps {
  companies: RelatedCompanyItem[]
}

const RelatedCompaniesSummary: React.FC<RelatedCompaniesSummaryProps> = ({ companies }) => {
  const theme = useTheme()
  const totalCount = companies.length
  const activeCount = companies.filter((c) => c.regStatus === '存续').length
  const matchTypes = Array.from(new Set(companies.map((c) => c.matchType))).length
  const regions = Array.from(new Set(companies.map((c) => c.base))).length

  const cardBackgroundColor = '#ffffff'

  return (
    <ItemWrapper>
      <LabeledTitle title="关联企业概览" />
      <Grid gutter="md">
        <Grid.Col span={3}>
          <Box
            ta="center"
            p="md"
            style={{
              backgroundColor: cardBackgroundColor,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#1c7ed6' }}>
              {totalCount}
            </Text>
            <Text size="sm" c="dimmed">
              关联企业总数
            </Text>
          </Box>
        </Grid.Col>
        <Grid.Col span={3}>
          <Box
            ta="center"
            p="md"
            style={{
              backgroundColor: cardBackgroundColor,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#22c55e' }}>
              {activeCount}
            </Text>
            <Text size="sm" c="dimmed">
              存续企业数
            </Text>
          </Box>
        </Grid.Col>
        <Grid.Col span={3}>
          <Box
            ta="center"
            p="md"
            style={{
              backgroundColor: cardBackgroundColor,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#a855f7' }}>
              {matchTypes}
            </Text>
            <Text size="sm" c="dimmed">
              关联类型数
            </Text>
          </Box>
        </Grid.Col>
        <Grid.Col span={3}>
          <Box
            ta="center"
            p="md"
            style={{
              backgroundColor: cardBackgroundColor,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <Text size="xl" fw={700} style={{ color: theme?.primaryColor || '#f97316' }}>
              {regions}
            </Text>
            <Text size="sm" c="dimmed">
              涉及地区数
            </Text>
          </Box>
        </Grid.Col>
      </Grid>
    </ItemWrapper>
  )
}

export default RelatedCompaniesSummary
